/**
 * Created by sumudu on 11/25/16.
 */
(function () {
    angular.module('trainingPrograms')
        .component('assignCrewSearchResult', {
            templateUrl: 'training-programs/components/training-assign-crew-search-result-component.tpl.html',
            controller: function (TrainingAssignCrewModel, TrainingAssignCrewLogic) {
                var vm = this;
                vm.crewList = [];
                vm.selectedTraining = null;
                vm.selectAllTrainees = false;

                vm.$onInit = function () {
                    TrainingAssignCrewModel.crewList.subscribe(function (crewList) {
                        vm.crewList = crewList;
                    });

                    TrainingAssignCrewModel.trainingDetails.subscribe(function (trainingDetails) {
                        vm.selectedTraining = trainingDetails;
                    })
                };

                vm.crewSelected = function (crew) {
                    if(!!crew.assignAs){
                        TrainingAssignCrewLogic.assignTrainerTrainee(crew.assignAs,vm.selectedTraining,crew, vm.selectAllTrainees);
                    }
                };

                vm.toggleAllTrainees = function () {
                  var selectedCrewList = [];

                  angular.forEach(vm.crewList, function (crew) {
                    crew.assignAs = vm.selectAllTrainees ? 'TRAINEE' : '';
                    if (!!crew.assignAs) {
                      selectedCrewList.push(crew);
                    }
                  });

                  if (selectedCrewList.length > 0) {
                    TrainingAssignCrewLogic.assignTrainerTrainee('TRAINEE', vm.selectedTraining, selectedCrewList, vm.selectAllTrainees);
                  }
                  vm.selectAllTrainees = false;
                  angular.forEach(vm.crewList, function (crew) {
                    crew.assignAs = '';
                  });
                };

              function parseDate(dateStr) {
                let parts = dateStr.split('/');
                let day = parseInt(parts[0], 10);
                let month = parseInt(parts[1], 10) - 1;
                let year = parseInt(parts[2], 10);
                return new Date(year, month, day);
              }


              vm.getExpiryStyle = function(fromDate, expiryDate) {
                if (!fromDate || !expiryDate) return {};

                const baseStyle = {
                  'border': '1px solid rgb(33, 33, 33)',
                  'border-radius': '5px',
                  'padding': '1px',
                  'color': 'rgb(33, 33, 33)'
                };

                const from = parseDate(fromDate);
                const expiry = parseDate(expiryDate);
                const diffDays = Math.ceil((expiry - from) / (1000 * 60 * 60 * 24));

                if (from > expiry) {
                  return Object.assign({}, baseStyle, {
                    'background-color': 'red',
                  });
                } else if (diffDays <= 30 && diffDays >= 0) {
                  return Object.assign({}, baseStyle, {
                    'background-color': '#FFBF00'
                  });
                } else {
                  return Object.assign({}, baseStyle, {
                    'background-color': 'white'
                  });
                }
              };

            },
            bindings: {}
        });
})();
